<template>
    <el-dialog
        title="重要信息提醒"
        :visible.sync="dialogVisible"
        width="30%"
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        class="tips"
    >
        <span
            class="title"
        >您的待办任务中有以下信息，请及时处理，以免影响结算流程，谢谢！</span>
        <span class="tip">提示：点击编号可以进入处理界面</span>
        <div class="content">
            <div
                v-if="tipsData.signs.length > 0"
                class="item"
            >
                <p>待签约合同编号:</p>
                <ul>
                    <li
                        v-for="(sign, index) of tipsData.signs || []"
                        :key="index"
                        @click="handleUnSign(sign)"
                    >
                        {{ (sign || {}).contractNo || "" }}
                    </li>
                </ul>
            </div>
            <div
                v-if="tipsData.confirms.length > 0"
                class="item"
            >
                <p>待确认退货单号:</p>
                <ul>
                    <li
                        v-for="(confirm, index) of tipsData.confirms || []"
                        :key="index"
                        @click="handleUnConfirm"
                    >
                        {{ confirm || "" }}
                    </li>
                </ul>
            </div>
        </div>
        <span
            slot="footer"
            class="dialog-footer"
        >
            <el-button
                type="primary"
                @click="handleComfirm"
            > 现在确认 </el-button>
            <el-button @click="handleCancel"> 暂不处理 </el-button>
        </span>
    </el-dialog>
</template>

<script>

const getItem = (key) => {
    try {
        return window.localStorage.getItem(key) || false;
    } catch (error) {
        return false;
    }
};

const setItem = (key, value) => {
    try {
        return window.localStorage.setItem(key, value);
    } catch (error) {
        return false;
    }
};

// 格式化时间 => {year, month, day}
const formateTime = (day) => ({
    year: day.getFullYear(),
    month: day.getMonth() + 1,
    day: day.getDate(),
});

// 比对校验是否是今天
const checkedDate = (time) => {
    const days = formateTime(new Date(+time));
    const now = formateTime(new Date());
    return (
        days.year === now.year && days.month === now.month && days.day === now.day
    );
};

// document.hidden 兼容
const getHidden = () => {
    const prefixs = ['webkit', 'moz', 'mos', 'o'];
    if ('hidden' in document) return document.hidden;
    for (let i = 0; i < prefixs.length; i++) {
        if (`${prefixs[i]}Hidden` in document) {
            return document[`${prefixs[i]}Hidden`];
        }
    }
    // not support
    return null;
};

const _record = '__isNotifyedCostToday';
const _isOpening = '__isOpeningNotify';

export default {
    props: {
        supplierInfo: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            unread: {
                knowledge: false,
            },
            dialogVisible: false,
            tipsData: {
                // 每日提示信息
                signs: [], // 待签约
                confirms: [], // 待确认
            },
        };
    },
    created() {
        this.getUnread();
    },
    mounted() {
        document.addEventListener(
            'visibilitychange',
            this.pageHiddenHandler,
            false,
        );
    },
    destroyed() {
        document.removeEventListener(
            'visibilitychange',
            this.pageHiddenHandler,
            false,
        );
    },
    methods: {
        async getUnread() {
            const res = await this.$hPost(
                '/api/m/vss/board/query/upcoming-summary',
                {},
            );
            if (res && res[2] && res[2].length) {
                this.unread.knowledge = true;
            }
            const unSignContract = await this.$hGet(
                '/api/m/vss/contract/pendingContract/url',
                {},
            );
            this.tipsData.signs = unSignContract.list || [];
            this.tipsData.confirms = res[1] || [];
            if (
                this.tipsData.signs.length === 0
        && this.tipsData.confirms.length === 0
            ) {
                this.dialogVisible = false;
            } else {
                this.saveToLocal();
            }
        },
        handleCancel() {
            this.$hGet('/api/m/vss/contract/pendingContract/notify')
                .then(() => {
                    this.setTimeToLocal();
                    this.dialogVisible = false;
                })
                .catch((err) => {
                    this.$message.error(err.message);
                });
        },
        handleComfirm() {
            this.dialogVisible = false;
            this.setTimeToLocal();
            this.$tools.linkTo('/index.html');
        },
        // 将结果存储到 LocalStorage
        saveToLocal() {
            if (!window.localStorage) return;
            const record = getItem(_record);
            const isOpening = getItem(_isOpening);

            // 判断是否有弹窗过
            if (record) {
                const _checked = checkedDate(record);
                // 判断时间是否是今天
                if (_checked) {
                    this.dialogVisible = false;
                    setItem(_isOpening, '');
                } else {
                    this.dialogVisible = !isOpening;
                    if (isOpening) setItem(_isOpening, 'true');
                }
            } else {
                this.dialogVisible = !isOpening;
                if (isOpening) setItem(_isOpening, 'true');
            }
        },
        setTimeToLocal() {
            const date = +new Date();
            setItem(_record, date);
        },
        handleUnSign(sign) {
            if (sign.url) this.$tools.linkTo(sign.url, {}, { isNewTab: true });
        },
        handleUnConfirm() {
            setItem(_isOpening, 'true');
            this.$tools.linkTo('/refund/list.html', {}, { isNewTab: true });
        },
        pageHiddenHandler() {
            const _this = this;
            const isHidden = getHidden();
            if (!isHidden) {
                _this.getUnread();
                setItem(_isOpening, '');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.tips {
  .title {
    color: red;
    font-weight: bold;
  }
  .content {
    display: flex;
    max-height: 500px;
    padding: 0;
    overflow-y: scroll;
    .item {
      flex: 1;
    }
    li {
      list-style: none;
      color: #4187ff;
      cursor: pointer;
      padding: 5px 0;
    }
  }
  .tip {
    display: inline-block;
    margin-top: 5px;
    color: red;
    font-size: 14px;
  }
}
</style>
